export default defineNuxtRouteMiddleware((to, from) => {
  const dayjs = useDayjs()
  const fat = useFatStore()

  // Check if FAT has city, otherwise set STHLM as city
  if (!fat.cityId) {
    fat.cityId = 86915
  }

  // Check if user is entering campaing page
  if (from.name && from.name !== to.name) {
    fat.setPreferredTimeWithOffset('19:00', 90)
  }

  // Set Tag ID's
  fat.tagIds = to.query?.tagIds?.length 
    ? to.query?.tagIds?.split(',')?.map(id => parseInt(id))
    : []

  // Add date query if missing
  if (!to.query?.date) {
    const startDate =  '2025-06-02'
    const endDate =  '2025-06-05'

    // Set today as date if campaign is active, otherwise use startDate as date
    const date = dayjs().isBetween(startDate, endDate, 'day', '(]')
      ? dayjs().format('YYYY-MM-DD')
      : startDate

    return navigateTo({ path: to.path, query: { ...to.query, date: date }})
  }
})
